import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import { connect, ReactReduxContext } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { AuthenticationState } from "react-aad-msal";
import Heading from "../heading/Heading";
import { Container, Row, Col, Button, Nav } from "react-bootstrap";
import { MobileAppSideMenu } from "./MobileAppSideMenu";
import EatCaterToggle from "./EatCaterToggle";
import { MobileHeaderBackArrow } from "./BackArrow";
import Sticky from "react-stickynode"; // Type defintitions

import * as TYPES from "../../types"; // Utilities

import * as UTIL from "../../util"; // Design System

import Logo from "../Logo";
import Modal from "../modal/Modal";
import Menu from "./Menu";
import SecondaryMenu from "./SecondaryMenu"; // Forms

import SearchBarForm from "../forms/SearchBar"; // Redux

import { waitlistDuck } from "../../ducks/waitlist";
var waitlistOperations = waitlistDuck.operations;

var MobileAppHeaderNav = /*#__PURE__*/function (_Component) {
  _inherits(MobileAppHeaderNav, _Component);

  var _super = _createSuper(MobileAppHeaderNav);

  // items = [];
  function MobileAppHeaderNav(props) {
    var _this;

    _classCallCheck(this, MobileAppHeaderNav);

    _this = _super.call(this, props);
    console.log('HEADER NAV PROPS', props);
    _this.state = {
      modalTitle: "Login",
      isVisible: false,
      formModalVisible: false,
      loginForm: true,
      searchActive: false,
      showPayInApp: props.showPayInApp || false,
      // MOBILE ONLY FEATURE
      hideBanner: false
    };
    _this.handleLogin = _this.handleLogin.bind(_assertThisInitialized(_this));
    _this.handleLogout = _this.handleLogout.bind(_assertThisInitialized(_this));
    _this.handleShowModal = _this.handleShowModal.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleExit = _this.handleExit.bind(_assertThisInitialized(_this));
    _this.handleSidebar = _this.handleSidebar.bind(_assertThisInitialized(_this));
    _this.toggleSearch = _this.toggleSearch.bind(_assertThisInitialized(_this));
    _this.closeSearch = _this.closeSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MobileAppHeaderNav, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        formModalVisible: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        formModalVisible: false
      });
    }
  }, {
    key: "handleExit",
    value: function handleExit() {
      this.setState({
        modalTitle: "Login",
        loginForm: true
      });
    }
  }, {
    key: "handleLogin",
    value: function handleLogin() {
      if (typeof this.props.handleLogin === "function") {
        return this.props.handleLogin();
      }

      return false;
    }
  }, {
    key: "handleSidebar",
    value: function handleSidebar() {
      if (typeof this.props.toggleSidenav === "function") {
        return this.props.toggleSidenav();
      }

      return false;
    }
  }, {
    key: "handleLogout",
    value: function handleLogout() {
      if (typeof this.props.handleLogout === "function") {
        return this.props.handleLogout();
      }

      return false;
    }
  }, {
    key: "toggleSearch",
    value: function toggleSearch(e) {
      this.setState({
        searchActive: !this.state.searchActive
      });
    }
  }, {
    key: "closeSearch",
    value: function closeSearch(e) {
      if (this.state.searchActive) {
        this.setState({
          searchActive: false
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$getShopCa = this.props.getShopCategories,
          getShopCategories = _this$props$getShopCa === void 0 ? function () {
        return console.log("getShopCategories");
      } : _this$props$getShopCa;
      getShopCategories();

      if (UTIL.loginUrl()) {
        if (typeof this.props.handleLogin === "function" && this.props.authenticationState !== AuthenticationState.Authenticated) {
          return this.props.handleLogin();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$secondary = _this$props.secondaryNavVisible,
          secondaryNavVisible = _this$props$secondary === void 0 ? false : _this$props$secondary,
          _this$props$accountNa = _this$props.accountNavVisible,
          accountNavVisible = _this$props$accountNa === void 0 ? false : _this$props$accountNa,
          model = _this$props.model,
          searchResults = _this$props.searchResults,
          _this$props$navigatio = _this$props.navigation,
          navigation = _this$props$navigatio === void 0 ? {} : _this$props$navigatio,
          _this$props$hamburger = _this$props.hamburgerMenuLinks,
          hamburgerMenuLinks = _this$props$hamburger === void 0 ? {} : _this$props$hamburger,
          _this$props$hamburger2 = _this$props.hamburgerMenuButtons,
          hamburgerMenuButtons = _this$props$hamburger2 === void 0 ? {} : _this$props$hamburger2,
          toggleWaitlist = _this$props.toggleWaitlist,
          searchChangeHandler = _this$props.searchChangeHandler,
          searchSubmitHandler = _this$props.searchSubmitHandler,
          authenticationState = _this$props.authenticationState,
          accountInfo = _this$props.accountInfo,
          newItem = _this$props.newItem,
          addTo = _this$props.addTo,
          cart = _this$props.cart,
          _this$props$close = _this$props.close,
          close = _this$props$close === void 0 ? function () {
        return "";
      } : _this$props$close,
          shopNav = _this$props.shopNav;
      var value = UTIL.mapNav(shopNav) || [];
      navigation.children = navigation.children.map(function (child) {
        if (child.url === "/shop") {
          child.children = value;
        }

        return child;
      });
      var _cart$cart = cart.cart,
          reduxCart = _cart$cart === void 0 ? [] : _cart$cart;
      var _this$state = this.state,
          formModalVisible = _this$state.formModalVisible,
          modalTitle = _this$state.modalTitle,
          loginForm = _this$state.loginForm,
          searchActive = _this$state.searchActive,
          showPayInApp = _this$state.showPayInApp;
      var items = navigation.children || [];
      return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
        var _this2$props, _this2$props$context, _this2$props$context$;

        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sticky, {
          enabled: true,
          top: 0,
          innerZ: 2
        }, /*#__PURE__*/React.createElement("div", {
          id: "mobileHeader",
          className: ""
        }, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this2.props, {
          store: _this2.props.store,
          authenticationState: authenticationState,
          secondaryNavVisible: secondaryNavVisible,
          onHide: _this2.handleSidebar,
          onLogin: _this2.handleLogin,
          handleLogout: _this2.handleLogout,
          handleShowSidebar: _this2.handleSidebar,
          toggleWaitlist: toggleWaitlist,
          links: hamburgerMenuLinks,
          buttons: hamburgerMenuButtons,
          model: model,
          showPayInApp: showPayInApp,
          openPayInApp: (_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : (_this2$props$context = _this2$props.context) === null || _this2$props$context === void 0 ? void 0 : (_this2$props$context$ = _this2$props$context.props) === null || _this2$props$context$ === void 0 ? void 0 : _this2$props$context$.openPayInApp
        })), /*#__PURE__*/React.createElement(HeaderWrapper, null, /*#__PURE__*/React.createElement(MobileAppCoreNav, {
          model: model,
          store: _this2.props.store,
          searchActive: searchActive,
          handleLogin: _this2.handleLogin,
          handleLogout: _this2.handleLogout,
          handleShowModal: _this2.handleShowModal,
          handleSidebar: _this2.handleSidebar,
          closeSearch: _this2.closeSearch,
          toggleSearch: _this2.toggleSearch,
          authenticationState: authenticationState,
          accountInfo: accountInfo,
          items: items,
          cartLength: reduxCart.length
        })))));
      }.bind(this));
    }
  }]);

  return MobileAppHeaderNav;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({}, state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleWaitlist: function toggleWaitlist() {
      return dispatch(waitlistOperations.toggleWaitlist());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppHeaderNav);
export { SecondaryMenu };
export var MobileAppCoreNav = function MobileAppCoreNav(props) {
  var _routeInfo$pageTitle, _routeInfo$pageTitle$, _routeInfo$pageTitle$2, _routeInfo$pageTitle$3;

  var model = props.model,
      searchActive = props.searchActive,
      handleShowModal = props.handleShowModal,
      handleLogin = props.handleLogin,
      handleLogout = props.handleLogout,
      handleSidebar = props.handleSidebar,
      closeSearch = props.closeSearch,
      toggleSearch = props.toggleSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      items = props.items,
      cartLength = props.cartLength,
      menu = props.menu,
      store = props.store;
  var routeInfo = UTIL.routerUtil.getCurrentRouteInfo(useLocation());
  var hideCleanedItem = UTIL.cleanObject(items, "hideInNavigation");
  var cleanedItem = UTIL.cleanTitleObject(hideCleanedItem, "navigationTitle");
  var canShowEatCaterToggle = routeInfo.isEatLandingPage || routeInfo.isCaterLandingPage;
  var canShowPageTitle = !(routeInfo.isEatLandingPage || routeInfo.isCaterLandingPage || routeInfo.isHomePage);
  var showSearchButton = false; // routeInfo.isHomePage;

  var showHamburgerButton = routeInfo.isHomePage;

  var NameTitle = function NameTitle() {
    var _accountInfo$account;

    if (accountInfo === null || accountInfo === void 0 ? void 0 : (_accountInfo$account = accountInfo.account) === null || _accountInfo$account === void 0 ? void 0 : _accountInfo$account.name) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
        className: "mb-0 pl-2 cb-type-font-veneer cb-color-brown-500",
        field: {
          value: 'HI THERE, '
        },
        level: 2
      }), /*#__PURE__*/React.createElement(Heading, {
        className: "mb-0 pl-2 cb-type-font-thirsty cb-color-brown-500",
        field: {
          value: accountInfo.account.name + " !"
        },
        level: 2
      }));
    } else {
      return /*#__PURE__*/React.createElement(Heading, {
        className: "mb-0 pl-2 cb-type-font-veneer cb-color-brown-500",
        field: {
          value: 'HI THERE!'
        },
        level: 2
      });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      minHeight: '70px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-100 d-flex align-items-center"
  }, routeInfo.isHomePage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex cb-header--proverride text-nowrap cb-font-veneer"
  }, NameTitle()))), !routeInfo.isHomePage && /*#__PURE__*/React.createElement("div", {
    className: canShowEatCaterToggle ? 'col-3' : 'col-2'
  }, /*#__PURE__*/React.createElement(MobileHeaderBackArrow, null)), canShowEatCaterToggle && /*#__PURE__*/React.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React.createElement(EatCaterToggle, {
    store: store,
    menu: menu
  })), canShowPageTitle && /*#__PURE__*/React.createElement("div", {
    className: "col-7"
  }, /*#__PURE__*/React.createElement(Heading, {
    className: "mb-0 text-center cb-type-font-veneer cb-color-brown-500",
    field: {
      value: (_routeInfo$pageTitle = routeInfo.pageTitle) === null || _routeInfo$pageTitle === void 0 ? void 0 : (_routeInfo$pageTitle$ = _routeInfo$pageTitle.replace('-', ' ')) === null || _routeInfo$pageTitle$ === void 0 ? void 0 : (_routeInfo$pageTitle$2 = _routeInfo$pageTitle$.replace('-', ' ')) === null || _routeInfo$pageTitle$2 === void 0 ? void 0 : (_routeInfo$pageTitle$3 = _routeInfo$pageTitle$2.replace('-', ' ')) === null || _routeInfo$pageTitle$3 === void 0 ? void 0 : _routeInfo$pageTitle$3.replace('-', ' ')
    },
    level: 2
  })), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement(MobileAppSideMenu, {
    searchActive: searchActive,
    mobile: true,
    showSearchButton: showSearchButton,
    showCartButton: !routeInfo.isHomePage && !routeInfo.isAMobilePayRoute,
    showHamburgerButton: showHamburgerButton,
    handleShowModal: handleShowModal,
    handleLogin: handleLogin,
    handleLogout: handleLogout,
    handleShowSidebar: handleSidebar,
    closeSearch: closeSearch,
    displaySearch: toggleSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    cartLength: cartLength
  })))));
};
export var SearchBar = function SearchBar(_ref) {
  var searchActive = _ref.searchActive,
      searchChangeHandler = _ref.searchChangeHandler,
      searchSubmitHandler = _ref.searchSubmitHandler,
      searchResults = _ref.searchResults;
  return /*#__PURE__*/React.createElement(Col, {
    className: "cb-header__search align-self-center d-block"
  }, /*#__PURE__*/React.createElement(SearchBarForm, {
    className: searchActive ? "is-active " : "",
    changeHandler: searchChangeHandler,
    submitHandler: searchSubmitHandler,
    results: searchResults
  }));
};
export var MobileSidebar = function MobileSidebar(props) {
  var searchActive = props.searchActive,
      handleLogin = props.handleLogin,
      handleShowModal = props.handleShowModal,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      toggleSearch = props.toggleSearch,
      cartLength = props.cartLength;
  return /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center d-none d-md-block cb-header__sideMenu"
  }, /*#__PURE__*/React.createElement(SideMenu, {
    searchActive: searchActive,
    mobile: false,
    handleLogin: handleLogin,
    handleShowModal: handleShowModal,
    handleShowSidebar: handleShowSidebar,
    closeSearch: closeSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    displaySearch: toggleSearch,
    cartLength: cartLength
  }));
};
export var HeaderWrapper = function HeaderWrapper(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-header a cb-bg-clay-wood"
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-header__container d-flex h-100"
  }, /*#__PURE__*/React.createElement(Row, null, children)));
};